import Login from "../pages/auth/Login";
import DashboardWrapper from "../pages/dashboard/DashboardWrapper";
import FileTree from "../pages/files/FileTree";
import AboutPage from "../pages/settings/AboutPage";
import StudyAbroadPage from "../pages/settings/StudyAbroad";
import Notifications from "../pages/settings/Notifications";
import Terms from "../pages/settings/Terms";
import Subjects from "../pages/settings/Subjects";
import CategoriesWrapper from "../pages/settings/categories/CategoriesWrapper";
import LessonTypesWrapper from "../pages/settings/lessonTypes/LessonTypesWrapper";
import ExpenseTypesWrapper from "../pages/settings/expenseTypes/ExpenseTypesWrapper";
import PromocodesWrapper from "../pages/settings/promocodes/PromocodesWrapper";
import PageSeoSettings from "../pages/settings/PageSeo";

import UsersWrapper from "../pages/users/UsersWrapper";
import StudentsWrapper from "../pages/students/StudentsWrapper";
import StudentProfile from "../pages/students/StudentProfile";
import TeachersWrapper from "../pages/teachers/TeachersWrapper";
import TeacherProfile from "../pages/teachers/TeacherProfile";
import CoursesWrapper from "../pages/courses/CoursesWrapper";
import PurchasedCoursesWrapper from "../pages/purchasedCourses/PurchasedCoursesWrapper";
import IncomeExpensesWrapper from "../pages/incomeExpenses/IncomeExpensesWrapper";
import SalariesWrapper from "../pages/finance/salaries/SalariesWrapper";
import TransactionsWrapper from "../pages/transactions/TransactionsWrapper";
import StatisticsWrapper from "../pages/statistics/StatisticsWrapper";
import BlogWrapper from "../pages/blog/BlogWrapper";
import EventsWrapper from "../pages/events/EventsWrapper";
import BranchesWrapper from "../pages/branches/BranchesWrapper";
import GalleryWrapper from "../pages/gallery/GalleryWrapper";
import TestimonialsWrapper from "../pages/testimonials/TestimonialsWrapper";
import ExamScoresWrapper from "../pages/examScores/ExamScoresWrapper";
import SubscribersWrapper from "../pages/subscribers/SubscribersWrapper";
import ContactFormsWrapper from "../pages/contactforms/ContactFormsWrapper";
import ClassroomScheduler from "../pages/classrooms/ClassroomScheduler";
import ClassroomsWrapper from "../pages/classrooms/ClassroomsWrapper";
import ClassroomDetails from "../pages/classrooms/ClassroomDetails";
import CalendarWrapper from "../pages/calendar/CalendarWrapper";

// import ProtectedRoute from "./routes/ProtectedRoute";

const routes = [
    {
        path: "/login",
        element: <Login />,
        isPublic: true,
        hasLayout: false,
    },
    {
        path: "/dashboard",
        element: <DashboardWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/about-page",
        element: <AboutPage />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/study-abroad",
        element: <StudyAbroadPage />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/notifications",
        element: <Notifications />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/terms",
        element: <Terms />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/page-seo",
        element: <PageSeoSettings />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/subjects",
        element: <Subjects />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/categories",
        element: <CategoriesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/lesson-types",
        element: <LessonTypesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/expense-types",
        element: <ExpenseTypesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/settings/promocodes",
        element: <PromocodesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/files",
        element: <FileTree />,
        isPublic: false,
        hasLayout: true,
    },
   
    //ADMIN
    {
        path: "/users",
        element: <UsersWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/students",
        element: <StudentsWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/students/:id",
        element: <StudentProfile />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/teachers",
        element: <TeachersWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/teachers/:id",
        element: <TeacherProfile />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/courses",
        element: <CoursesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/purchased-courses",
        element: <PurchasedCoursesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/income-expenses",
        element: <IncomeExpensesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/salaries",
        element: <SalariesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/transactions",
        element: <TransactionsWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/statistics",
        element: <StatisticsWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/classroom-scheduler",
        element: <ClassroomScheduler />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/classrooms",
        element: <ClassroomsWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/classrooms/:id",
        element: <ClassroomDetails />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/calendar",
        element: <CalendarWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/blog",
        element: <BlogWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/events",
        element: <EventsWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/branches",
        element: <BranchesWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/gallery",
        element: <GalleryWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/testimonials",
        element: <TestimonialsWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/exam-scores",
        element: <ExamScoresWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/subscribers",
        element: <SubscribersWrapper />,
        isPublic: false,
        hasLayout: true,
    },
    {
        path: "/contact-forms",
        element: <ContactFormsWrapper />,
        isPublic: false,
        hasLayout: true,
    }

];

export default routes

